'use client';

import { c as _c } from "react/compiler-runtime";
import { usePosthogCapture } from '@repo/sdk/analytics/posthog';
import { useMutation } from '@repo/sdk/tanstack';
import { useUpFetch } from '@repo/sdk/upfetch';
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Separator, Spinner, toast, Toggle } from '@repo/ui/components';
import { CalendarDays } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib';
import { useEffect, useState } from 'react';
import { useWelcomeModalContext } from '@/app/_components/welcome-modal/context.tsx';
import CalendarDropdown from '@/app/_components/welcome-modal/input/calendar-dropdown.tsx';
export const CallbackForm = () => {
  const $ = _c(73);
  const {
    inquiryLoadId,
    setIsOpen
  } = useWelcomeModalContext();
  const [isASAP, setIsASAP] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      date: new Date(),
      time: {
        from: {
          hour: "08",
          min: "00"
        },
        type: "at"
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [dateTime, setDateTime] = useState(t0);
  const {
    posthogCapture
  } = usePosthogCapture();
  let t1;
  if ($[1] !== posthogCapture) {
    t1 = () => posthogCapture("welcome: user enters callback view");
    $[1] = posthogCapture;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = date => {
      setDateTime(prev => ({
        ...prev,
        date
      }));
      setIsASAP(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectDate = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = hour => {
      setDateTime(prev_0 => ({
        ...prev_0,
        time: {
          ...prev_0.time,
          from: {
            ...prev_0.time.from,
            hour
          }
        }
      }));
      setIsASAP(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setHour = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = minute => {
      setDateTime(prev_1 => ({
        ...prev_1,
        time: {
          ...prev_1.time,
          from: {
            ...prev_1.time.from,
            minute
          }
        }
      }));
      setIsASAP(false);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const setMinute = t4;
  const upFetch = useUpFetch();
  let t5;
  if ($[6] !== dateTime.date || $[7] !== dateTime.time.from.hour || $[8] !== dateTime.time.from.min || $[9] !== dateTime.time.type || $[10] !== inquiryLoadId || $[11] !== isASAP || $[12] !== upFetch) {
    t5 = async () => {
      const data = isASAP ? {
        date: new Date(),
        time: {
          type: "asap"
        }
      } : {
        date: dateTime.date,
        time: {
          from: `${dateTime.time.from.hour}:${dateTime.time.from.min}`,
          type: dateTime.time.type
        }
      };
      await upFetch(`/inquiry-loads/${inquiryLoadId}/book-call`, {
        body: data,
        method: "POST"
      });
    };
    $[6] = dateTime.date;
    $[7] = dateTime.time.from.hour;
    $[8] = dateTime.time.from.min;
    $[9] = dateTime.time.type;
    $[10] = inquiryLoadId;
    $[11] = isASAP;
    $[12] = upFetch;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== setIsOpen) {
    t6 = () => {
      toast.success("We will contact you soon");
      setIsOpen(false);
    };
    $[14] = setIsOpen;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = {
      mutationFn: t5,
      onSuccess: t6
    };
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const {
    isPending,
    mutate
  } = useMutation(t7);
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex flex-col gap-6 transition-all duration-400");
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = isASAP && "[&_*]:text-gray-400 [&_.border]:border-gray-100";
  let t10;
  if ($[20] !== t9) {
    t10 = cn("flex items-center justify-center gap-2 text-xs", t9);
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = isASAP && "dark:bg-background bg-gray-200 dark:opacity-40";
  let t12;
  if ($[22] !== t11) {
    t12 = cn("flex items-center gap-4 rounded-xl border px-3 py-2 max-[500px]:max-w-32", t11);
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CalendarDays />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p className="text-gray-500">Select date:</p>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== dateTime.date) {
    t15 = <div className="flex flex-col">{t14}<CalendarDropdown label="" onChange={selectDate} value={dateTime.date} /></div>;
    $[26] = dateTime.date;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <div className={t12}>{t13}{t15}</div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p>at</p>;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = dateTime.time.from.hour;
  const t19 = isASAP && "dark:bg-background bg-gray-200 dark:opacity-40";
  let t20;
  if ($[32] !== t19) {
    t20 = cn("border-inherit outline-none focus:ring-transparent", t19);
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SelectValue />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20) {
    t22 = <SelectTrigger className={t20}>{t21}</SelectTrigger>;
    $[35] = t20;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <SelectContent className="dark:bg-background min-w-min">{["08", "09", "10", "11", "12", "13", "14", "15", "16"].map(_temp)}</SelectContent>;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== dateTime.time.from.hour || $[39] !== t22) {
    t24 = <Select defaultValue={t18} onValueChange={setHour}>{t22}{t23}</Select>;
    $[38] = dateTime.time.from.hour;
    $[39] = t22;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <p>:</p>;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = dateTime.time.from.min;
  const t27 = isASAP && "dark:bg-background bg-gray-200 dark:opacity-40";
  let t28;
  if ($[42] !== t27) {
    t28 = cn("border-inherit outline-none focus:ring-transparent", t27);
    $[42] = t27;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SelectValue />;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t28) {
    t30 = <SelectTrigger className={t28}>{t29}</SelectTrigger>;
    $[45] = t28;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  let t31;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SelectContent className="min-w-min">{["00", "15", "30", "45"].map(_temp2)}</SelectContent>;
    $[47] = t31;
  } else {
    t31 = $[47];
  }
  let t32;
  if ($[48] !== dateTime.time.from.min || $[49] !== t30) {
    t32 = <Select defaultValue={t26} onValueChange={setMinute}>{t30}{t31}</Select>;
    $[48] = dateTime.time.from.min;
    $[49] = t30;
    $[50] = t32;
  } else {
    t32 = $[50];
  }
  let t33;
  if ($[51] !== t10 || $[52] !== t16 || $[53] !== t24 || $[54] !== t32) {
    t33 = <div className={t10}>{t16}{t17}{t24}{t25}{t32}</div>;
    $[51] = t10;
    $[52] = t16;
    $[53] = t24;
    $[54] = t32;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  let t34;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="flex items-center gap-6"><Separator className="shrink" /><p className="font-semibold">or</p><Separator className="shrink" /></div>;
    $[56] = t34;
  } else {
    t34 = $[56];
  }
  let t35;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = state => setIsASAP(state);
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== isASAP) {
    t36 = <div className="flex items-center justify-center"><Toggle className="data-[state=on]:bg-gray-900 data-[state=on]:text-white" onPressedChange={t35} pressed={isASAP} variant="outline">As soon as you can</Toggle></div>;
    $[58] = isASAP;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== mutate || $[61] !== posthogCapture) {
    t37 = () => {
      posthogCapture("welcome: user requests a callback");
      mutate();
    };
    $[60] = mutate;
    $[61] = posthogCapture;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  let t38;
  if ($[63] !== isPending) {
    t38 = isPending && <Spinner />;
    $[63] = isPending;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== isPending || $[66] !== t37 || $[67] !== t38) {
    t39 = <Button className="font-semibold uppercase" disabled={isPending} onClick={t37}>Book a call {t38}</Button>;
    $[65] = isPending;
    $[66] = t37;
    $[67] = t38;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  let t40;
  if ($[69] !== t33 || $[70] !== t36 || $[71] !== t39) {
    t40 = <div className={t8}>{t33}{t34}{t36}{t39}</div>;
    $[69] = t33;
    $[70] = t36;
    $[71] = t39;
    $[72] = t40;
  } else {
    t40 = $[72];
  }
  return t40;
};
function _temp(item) {
  return <SelectItem key={item} value={item}>{item}</SelectItem>;
}
function _temp2(item_0) {
  return <SelectItem key={item_0} value={item_0}>{item_0}</SelectItem>;
}